// GET USER LIST

export const USER_ROLE = "USER_ROLE"
export const USER_ROLE_SUCCESS = "USER_ROLE_SUCCESS"
export const USER_DATA = "USER_DATA"
export const USER_DATA_SUCCESS = "USER_DATA_SUCCESS"
export const ALL_USER_DATA_SUCCESS = "ALL_USER_DATA_SUCCESS"
export const USER_DATA_ERROR = "USER_DATA_ERROR"

// ADD NEW USER
export const ADD_NEW_USER = "ADD_NEW_USER"
export const ADD_NEW_USER_SUCCESS = "ADD_NEW_USER_SUCCESS"
export const ADD_NEW_USER_ERROR = "ADD_NEW_USER_ERROR"

// UPDATE USER
export const UPDATE_NEW_USER = "UPDATE_NEW_USER"
export const UPDATE_NEW_USER_SUCCESS = "UPDATE_NEW_USER_SUCCESS"
export const UPDATE_NEW_USER_ERROR = "UPDATE_NEW_USER_ERROR"

//DELETE USER 
export const DELETE_USER_BYID = "DELETE_USER_BYID"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_ERROR = "DELETE_USER_ERROR"

//BULK UPLOAD
export const BULK_UPLOAD = "BULK_UPLOAD"
export const BULK_UPLOAD_SUCCESS = "BULK_UPLOAD_SUCCESS"
export const BULK_UPLOAD_ERROR = "BULK_UPLOAD_ERROR"

